import { client } from '../client';

export interface Payload {
  email: string;
  password: string;
  organization_id?: string;
  division_id?: string;
  practice_id?: string;
  client?: string;
  handle_existing_user?: boolean;
  client_access_code?: string;
}

export interface LoginResponse {
  access_token?: string;
  refresh_token?: string;
  role?: string;
  mfa_method?: string;
  session_id?: string;
  redirect_url?: string;
  email?: string;
  phone_number?: string;
}
export const login = async (payload: Payload): Promise<LoginResponse> => {
  const { data } = await client.post<LoginResponse>(`/auth/login`, payload);

  return data;
};
